<template>
  <Modal v-model="visible" title="明细" width="800" :footer-hide="true" :mask-closable="false" class="my-modal top static">
    <Table :columns="columns" :data="tableData"></Table>
  </Modal>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      tableData: [],
      columns: [
        {
          title: '佣金项类型',
          align: 'center',
          key: 'commissionType',
          minWidth: 120,
          render(h, params) {
            const value = params.row.commissionType;
            let commissionTypeMap = {
              1: '周边收支',
              2: '佣金调整'
            };
            return <span>{commissionTypeMap[value]}</span>;
          }
        },
        {
          title: '保单编号',
          align: 'center',
          key: 'policyNo',
          minWidth: 120
        },
        {
          title: '收支类型',
          align: 'center',
          key: 'incomeType',
          minWidth: 100,
          render(h, params) {
            const value = params.row.incomeType;
            if (value == 1) return <span>收入</span>;
            if (value == 2) return <span>支出</span>;
            return <span>-</span>;
          }
        },
        {
          title: '积分（港币）',
          align: 'center',
          key: 'settleCommissionPrice',
          minWidth: 130
        },
        {
          title: '备注',
          align: 'center',
          key: 'remark',
          minWidth: 150,
          render(h, params) {
            return <span>{params.row.remark || '-'}</span>;
          }
        }
      ]
    };
  },
  methods: {
    open(params) {
      this.$http({
        url: params.apiPrefix + '/summaryDataDetail',
        type: 'GET',
        data: {
          id: params.id,
          owerId: params.owerId
        }
      }).then(res => {
        this.tableData = res.data || [];
        this.visible = true;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
/deep/.ivu-modal-body{
  padding-top: 20px !important;
  padding-bottom: 20px !important;
}
</style>
